import { createFileRoute } from "@tanstack/react-router";
import { DataQualityCard } from "../components/settings/data-quality/DataQualityCard";
import { VisitDataCard } from "../components/settings/data-quality/VisitDataCard";

export const Route = createFileRoute("/_auth/settings/data-quality")({
  staticData: {
    titleKey: "settings.dataQuality.title",
    breadcrumbKey: "breadcrumb.manage",
    breadcrumbN: 2,
  },
  component: DataQualityPage,
});

function DataQualityPage() {
  return (
    <>
      <VisitDataCard />
      <DataQualityCard />
    </>
  );
}
